import { UIComponentViewImpl } from '../../../toolkit/uicomponentview';
import { UIDataModel, UIComponentState } from '../../../toolkit/uicomponent';
import { ConfirmationComponentProps } from './confirmationcomponent';
import { ConfirmationCSSStyle } from './confirmationcss';
import * as React from 'react';
import { Strings } from '../../../../utils/resources/strings';
import { ButtonComponent } from '../../../toolkit/button/buttoncomponent';
import { RoutingFeatures } from '../../navigation/routingfeature';
import { ConfirmRequestConfirmButtonCSSStyleImpl } from '../../popup/confirmrequest/confirmrequestconfirmbuttoncss';

import './confirmation-style.css';

export class ConfirmationViewImpl extends UIComponentViewImpl<UIDataModel>
{
    bindHandlers()
    {
        this.onLoginClicked = this.onLoginClicked.bind(this);
        this.onLogoClicked = this.onLogoClicked.bind(this);
    }

    draw(props: ConfirmationComponentProps, state: UIComponentState, cssStyle: ConfirmationCSSStyle): JSX.Element | boolean
    {
        super.draw(props, state, cssStyle);

        return (
            <div id="confirmation-page-wrapper" style={cssStyle.getWrapperCSSStyle()}>
                <div id="confirmation-page-inner-wrapper" style={cssStyle.getInnerWrapperCSSStyle()}>
                    {/* <img id="confirmation-page-logo" onClick={this.onLogoClicked} style={{cursor: "pointer",marginLeft: "-140px",width:'100%',height:"80px",marginBottom:'54px',marginTop:'0px'}} src={props.context.getResources().getImage("mpt_logo.svg")}  /> */}
                    <img id="confirmation-page-logo" onClick={this.onLogoClicked} style={{cursor: "pointer", marginBottom:'54px',marginTop:'0px'}} src={props.context.getResources().getImage("mpt_logo.svg")}  />
                    <label id="confirmation-page-heading" style={cssStyle.getTitleCSSStyle()}>{props.context.getResources().getString(Strings.successfull)}</label>
                    
                
                <div id="confirmation-page-message-wrapper" style={cssStyle.getMessageDivCSSStyle()}>
                    <label>{props.message}</label>
                </div> 
                <div style={cssStyle.getLoginButtonCSSStyle()}>
                        <ButtonComponent onClick={this.onLoginClicked} style={new ConfirmRequestConfirmButtonCSSStyleImpl(props.context)} context={props.context} label={props.context.getResources().getString(Strings.login_now)}/>
                </div>
             </div>
            </div>
        );
    }

    protected onLogoClicked()
    {
        this.getUIProps().context.getRedirectionHandler().routeNextFeature(RoutingFeatures.HOME, false);
    }
    private onLoginClicked()
    {
        (this.getUIProps() as ConfirmationComponentProps).onClick();
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/login/confirmation/confirmationview.tsx